import React from 'react';

export default function MessageBubble({ message, isSender, createdAt, mensagemLida }) {    

    function formatDate(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    }
    return (
        <div className={`message-bubble ${isSender ? 'sender' : 'receiver'}`}>
            <p>{message}</p>
            <small className="message-date">{formatDate(createdAt)}</small>
            {isSender && (
            <small className={`message-status ${mensagemLida ? 'read' : 'unread'}`}>
              {mensagemLida ? '✔✔ Lida' : '✔ Enviada'}
            </small>
          )}

        </div>
    );
}

